export default __webpack_public_path__ + "static/media/indicator-gray.335105fc.svg";